import { MouseEvent, useState, useEffect } from 'react';
import { IAnswer } from '../data/interfaces';

type Props = {
  sort: number;
  answer: IAnswer;
  correct: string;
  isCorrectSelected: boolean;
  selectDone: boolean;
  onSelect: (correct: boolean) => void;
};

export default ({
  sort,
  answer,
  correct,
  isCorrectSelected,
  selectDone,
  onSelect,
}: Props) => {
  const [isCorrect, setIsCorrect] = useState(0);
  const [mainClass, setMainClass] = useState('answer');

  useEffect(() => {
    let classes = 'a_text';
    switch (isCorrect) {
      case 2:
        classes += ' success';
        break;
      case 1:
        classes += ' fail';
        break;
      default:
        break;
    }
    setMainClass(classes);
  }, [isCorrect]);

  useEffect(() => {
    if (isCorrectSelected && answer.variant === correct) {
      setTimeout(() => setIsCorrect(2), 300);
    }
  }, [isCorrectSelected, answer.variant, correct]);

  const handleSelect = (e: MouseEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    setIsCorrect(input.value === correct ? 2 : 1);
    onSelect(input.value === correct);
  };

  return (
    <div className="answer">
      <input
        type="radio"
        name={sort.toString()}
        value={answer.variant}
        onClick={handleSelect}
        disabled={selectDone}
      />
      <span className="variant">{answer.variant}. </span>
      <span className={mainClass}>{answer.answer}</span>
    </div>
  );
};
